<template>
  <DatePicker
    @on-change="selectDate"
    type="month"
    placeholder="选择月份"
    v-model="date"
  ></DatePicker>
</template>
<script>
export default {
  props: ["date1"],
  data() {
    return {
      date: "",
    };
  },
  methods: {
    selectDate(v) {
      this.$emit("abc", this.utils.toSjc(this.date));
    },
  },
  mounted() {
    if (this.date1 != undefined) {
      this.date = new Date(this.date1);
    }
    this.$emit("abc", this.utils.toSjc(this.date));
  },
  model: {
    prop: "date1",
    event: "abc",
  },
  watch: {
    date1(v) {
      this.date = new Date(v);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/lyyymm.vue